/* unplugin-vue-components disabled */import script from "./pop.vue?vue&type=script&setup=true&name=pop&lang=js"
export * from "./pop.vue?vue&type=script&setup=true&name=pop&lang=js"

import "./pop.vue?vue&type=style&index=0&id=e2c9166a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c9166a"]])

export default __exports__